import React from "react";
import Select from "react-select";
import { useQuery } from "@tanstack/react-query";
import { fetchCollectionType } from "services/dropdown";
import { DROPDOWN_STALE_TIME } from "utils/constants";
import { Controller } from "react-hook-form";

const CollectionTypeDropdown = ({
  errors,
  control,
  setValue,
  getValues,
  watch,
  required
}) => {
  const collectionType = getValues().collection_type;
  const selectedCollectionType = watch("collection_type_id");

  const {
    data: collectionTypes,
    isLoading,
    error,
  } = useQuery(["collectionTypes"], () => fetchCollectionType(), {
    keepPreviousData: false,
    staleTime: DROPDOWN_STALE_TIME,
  });

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading Collection Types</div>;

  const modifiedData = collectionTypes?.data?.data?.map((ele) => ({
    ...ele,
    collection_type_id: ele.id,
  }));

  const options =
    modifiedData?.map((collection) => ({
      value: collection.collection_type_id,
      label: collection.collection_type,
    })) || [];

  const selectedOption = options.find(
    (option) => option.value === selectedCollectionType || collectionType
  );
  return (
    <Controller
      name="collection_type_id"
      control={control}
      rules={{
        required: required ? "Collection Type is required" : false,
        validate: (value) => {
          if (required && !value) return "Collection Type is required";
          return true;
        },
      }}
      render={({ field }) => (
        <Select
          {...field}
          options={options}
          isClearable
          value={selectedOption || null}
          placeholder="Select Collection Type"
          menuPortalTarget={document.body}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          }}
          onChange={(selectedOption) => {
            const value = selectedOption ? selectedOption.value : "";
            field.onChange(value);
            setValue("collection_type_id", value);
          }}
          className={`react-select-container ${errors.collection_type_id ? "is-invalid" : ""
            }`}
        />
      )}
    />
  );
};

export default CollectionTypeDropdown;
